import { useCallback, useEffect, useMemo, useState } from 'react';
import { getExportItemIds } from './exportConfigUtils';

export const useExportSelection = (exportConfig) => {
  const allIds = useMemo(() => getExportItemIds(exportConfig), [exportConfig]);
  const [selectedIds, setSelectedIds] = useState(() => new Set(allIds));

  useEffect(() => {
    setSelectedIds(new Set(allIds));
  }, [allIds]);

  const toggleItem = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const selectAll = useCallback(() => {
    setSelectedIds(new Set(allIds));
  }, [allIds]);

  const clearAll = useCallback(() => {
    setSelectedIds(new Set());
  }, []);

  const isSelected = useCallback((id) => selectedIds.has(id), [selectedIds]);

  const selectedItems = useMemo(() => {
    const items = [];
    exportConfig.sections.forEach((section) => {
      section.items.forEach((item) => {
        if (selectedIds.has(item.id)) {
          items.push(item);
        }
      });
    });
    return items;
  }, [exportConfig.sections, selectedIds]);

  return {
    selectedIds,
    selectedItems,
    selectedCount: selectedIds.size,
    toggleItem,
    selectAll,
    clearAll,
    isSelected,
  };
};
